import { combineReducers } from "redux";

import capiReducer, {
  initialState as initialCapiState
} from "./App/capiReducer";

import userDataReducer, {
  initialState as initialUserState
} from "./App/userDataReducer";

import appReducer, { initialState as initialAppState } from "./App/appReducer";

import modalReducer, {
  initialState as initialModalState
} from "./App/modalReducer";

export const initialState = {
  capi: initialCapiState,
  userData: initialUserState,
  app: initialAppState,
  modal: initialModalState
};

export default combineReducers({
  capi: capiReducer,
  userData: userDataReducer,
  app: appReducer,
  modal: modalReducer
});
